import React from 'react';
function Database({ size, stroke = 'currentColor', ...otherProps }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke={stroke}
      {...otherProps}
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M12 8c4.418 0 8-1.12 8-2.5S16.418 3 12 3 4 4.12 4 5.5 7.582 8 12 8zM20 12c0 1.66-3.556 3-8 3s-8-1.34-8-3"
      />
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M4 6v12.353C4 19.818 7.556 21 12 21s8-1.182 8-2.647V6"
      />
    </svg>
  );
}

export default Database;
